var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('v-btn',{attrs:{"x-small":""},on:{"click":function($event){return _vm.CopyContentToClipboard()}}},[_c('v-icon',{attrs:{"x-small":""}},[_vm._v(" mdi-content-copy ")])],1),_c('pre',{domProps:{"innerHTML":_vm._s(_vm.JsonTree(_vm.value, _vm.name))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }